<template>
  <div class="flex flex-wrap">
    <span
      v-for="tag in tags"
      :key="tag.slug"
      class="rounded-md px-2 py-0.5 mr-2 mt-2 bg-depth-2 capitalize font-bold"
      :class="{ 'text-brand': tag.slug === 'popular' }"
    >
      {{ $t(`${tag.translationKey.namespace}/${tag.translationKey.key}`) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { StrapiMinecraftModpackTag } from '#variant/apollo/types/types';

defineProps<{
  tags: StrapiMinecraftModpackTag[];
}>();
</script>
